<template>
  <div class="form">
    <div class="item">
      <div class="field">車種</div>
      <div class="carType">
        <div :class="{'radio-group': true, 'active': carType=='M'}" @click.prevent="carType = 'M'" style="margin-right: 8pt">
          <input type="radio" id="motorcycle" name="carType" v-model="carType" value="M" />
          <label for="motorcycle">機車</label>
        </div>
        <div :class="{'radio-group': true, 'active': carType=='C'}" @click.prevent="carType = 'C'" style="margin-left: 8pt">
          <input type="radio" id="car" name="carType" v-model="carType" value="C" />
          <label for="car">汽車</label>
        </div>
        <div :class="{'radio-group': true, 'active': carType=='B'}" @click.prevent="carType = 'B'" style="margin-left: 8pt" v-if="this.isTrailerEnabled">
          <input type="radio" id="trailer" name="carType" v-model="carType" value="B" />
          <label for="trailer">拖車</label>
        </div>
        <div :class="{'radio-group': true, 'active': carType=='H'}" @click.prevent="carType = 'H'" style="margin-left: 8pt" v-if="this.isHeavyMotorcycleEnabled">
          <input type="radio" id="heavymotocycle" name="carType" v-model="carType" value="H" />
          <label for="trailer">重機</label>
        </div>
        <div :class="{'radio-group': true, 'active': carType=='M1'}" @click.prevent="carType = 'M1'" style="margin-left: 8pt" v-if="this.isSlowVehicleEnabled">
          <input type="radio" id="slowVehicle" name="carType" v-model="carType" value="M1" />
          <label for="trailer">微電車</label>
        </div>
      </div>
    </div>
    
    <div class="item">
      <div class="field">
        車號
        <span class="text-gray2"  v-if="carType !== 'M1'">（範例：ABC-1234 或 1234-ABC）</span>
        <span class="text-gray2"  v-else>（範例：AB12345）</span>
      </div>
      <div v-if="carType === 'M1'">
        <div class="carNumber slowVehicle">
          <input name="carNumber" v-model.trim="number" maxlength="7" @keyup="changeCarNumber" ref="number" autocomplete="off"  :class="!isVerifyError ? '' : 'error'"/>        
        </div>
        <div class="required" v-if="isVerifyError">前 2 碼限英文，後 5 碼限數字</div>
      </div>
      <div class="carNumber" v-else>
        <input name="carNumber0" v-model.trim="number0" maxlength="4" @keyup="changeValue0" ref="number0" autocomplete="off" />
        <span class="space-line"></span>
        <input name="carNumber1" v-model.trim="number1" maxlength="4" @keyup="changeValue1" ref="number1" autocomplete="off" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'roadside-parking-form',
  props: {
    isTrailerEnabled: {
      type: Boolean,
      default: false
    },
    isHeavyMotorcycleEnabled: {
      type: Boolean,
      default: false
    },
    isSlowVehicleEnabled: {
      type: Boolean,
      default: false
    },
    form: {},
  },
  data() {
    return {
      carNumber: '',
      carNumber0: '',
      carNumber1: '',
      carType: 'M',
    };
  },
  mounted() {
  },
  computed: {
    isVerifyError: {
      get: function () {
        let error = this.number.length > 0 && !this.$parent.isValidSlowVehicleNumber(this.number);
        return error;
      },
    },
    number: {
      get: function () {
        return this.carNumber;
      },
      set: function (val) {
        var number = val.toUpperCase().replace(/\s/g, '');
        if (number.length > 7) {
          number = number.substring(0, 7);
        }
        this.carNumber = number;
      },
    },
    number0: {
      get: function () {
        return this.carNumber0;
      },
      set: function (val) {
        var number = val.toUpperCase().replace(/\s/g, '');
        if (number.length > 4) {
          number = number.substring(0, 4);
        }
        this.carNumber0 = number;
      },
    },
    number1: {
      get: function () {
        return this.carNumber1;
      },
      set: function (val) {
        var number = val.toUpperCase().replace(/\s/g, '');
        if (number.length > 4) {
          number = number.substring(0, 4);
        }
        this.carNumber1 = number;
      },
    },
  },
  methods: {
    changeCarNumber(e) {
      e.target.value = e.target.value.replace(/[\W]/g, '');
      if (this.number.length >= 7) {
        this.$refs.number.blur();
      }
    },
    changeValue0(e) {
      e.target.value = this.trimLength(e.target.value.replace(/[\W]/g, ''), 4);
      if (this.number0.length >= 4) {
        this.$refs.number1.focus();
      }
    },
    changeValue1(e) {
      e.target.value = this.trimLength(e.target.value.replace(/[\W]/g, ''), 4);
      if (this.number1.length >= 4) {
        this.$refs.number1.blur();
      }
    },
    trimLength(string, length) {
      return string.length > length ? 
             string.substring(0, length) :
             string;
    },  
  },
  watch: {
    carNumber() {
      this.$emit('getFormData', 'carNumber', this.carNumber);
    },
    carNumber0() {
      var num = this.carNumber0 + '-' + this.carNumber1;
      this.$emit('getFormData', 'carNumber', num);
    },
    carNumber1() {
      var num = this.carNumber0 + '-' + this.carNumber1;
      this.$emit('getFormData', 'carNumber', num);
    },
    carType() {
      if (this.carType === 'M1') {
        this.$emit('getFormData', 'carNumber', this.carNumber);
      } else {
        var num = this.carNumber0 + '-' + this.carNumber1;
        this.$emit('getFormData', 'carNumber', num);
      }
      this.$emit('getFormData', 'carType', this.carType);

    },
  },
};
</script>

<style scoped>
.form .item {
  margin-top: 24pt;
}

.carNumber {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.carNumber input {
  background: rgba(64, 64, 64, 0.05);
  border: none;
  font-size: 16px;
  line-height: 30px;
  padding: 11pt 0;
  width: 50%;
  text-align: center;
}

.carNumber.slowVehicle input {
  width: 100%;
}

.carType {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.carType .radio-group {
  padding: 11pt 0;
  border: 1px solid rgba(64, 64, 64, 0.1);
  border-radius: 4pt;
  display: flex;
  justify-content: center;
  width: 50%;
  align-items: center;
  -webkit-box-sizing: border-box;
  -webkit-transition: background ease-in 0.1s;
}

.carType .radio-group.active {
  background: #f9b238;
  color: #fff;
  font-size: 16px;
}

.carType .radio-group input[type='radio'] {
  display: none;
}

.space-line {
  margin: 0 8pt;
  background: #000;
  height: 1px;
  content: '';
  display: block;
  width: 20pt;
}


.required {
  margin-top: 2pt;
  margin-bottom: 26pt;
  font-size: 12pt;
}
</style>
